import { render, staticRenderFns } from "./systemData.vue?vue&type=template&id=ef4d9a24&scoped=true"
import script from "./systemData.vue?vue&type=script&lang=js"
export * from "./systemData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4d9a24",
  null
  
)

export default component.exports